<template>
    <CollapsibleCard
        class="border-gray"
        body-class="p-2"
        :collapsed="collapsed"
        @update:collapsed="$emit('update:collapsed', $event)"
    >
        <template #title>
            <h5 class="card-title mb-0">
                {{ $t('Component(Text):information-requested') }}
            </h5>
        </template>

        <div>
            <RequestInformationDetails :request="request" />
        </div>
        <hr class="my-2">
        <div>
            <CoveredLegislations :legislations="request.legislations" />
        </div>
    </CollapsibleCard>
</template>

<script>
import CollapsibleCard from '@core/components/common/CollapsibleCard.vue'
import CoveredLegislations from './CoveredLegislations.vue'
import RequestInformationDetails from './RequestInformationDetails.vue'

export default {
    name: 'ManifestRequestInformation',
    components: {
        CollapsibleCard,
        CoveredLegislations,
        RequestInformationDetails,
    },
    props: {
        request: {
            type: Object,
            required: true,
        },
        collapsed: {
            type: Boolean,
            default: null,
        },
    },
}
</script>
